import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';

export default function Layout({ children }) {
  return (
    <LanguageProvider>
      <style>{`
        html, body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          width: 100%;
          height: 100%;
        }
        #root {
          width: 100%;
          height: 100%;
        }
      `}</style>
      {children}
    </LanguageProvider>
  );
}